import { gql } from "@apollo/client";

const PRODUCT_AVAILABLE_QUERY = gql`
	query ProductAvailability($enterpriseProductId: ID!) {
		productAvailabilityByRetailer(
			enterpriseProductId: $enterpriseProductId
		) {
			isAvailable
			retailer {
				id
				name
			}
			productId
		}
	}
`;
export default PRODUCT_AVAILABLE_QUERY;